module.exports = __webpack_public_path__ + "img/01d.2d0ec2a2.png";